<template>
  <custom-callout
    :border-color="'orangeLight'"
    class="mb-4 custom-callout bg-gray"
    :custom-class="'orangeLight'"
    :has-toggle="false"
  >
    <div class="pb-2">
      <div class="d-flex">
        <icon-view
          class="mt-5 mb-3 mt-md-0 mt-sm-5"
          :gradient="false"
          icon="fas fa-file-invoice"
          icon-background="white"
          icon-color="#ff7058"
          icon-size="16px"
          title="Crear Nueva Factura"
        />
      </div>
      <validation-observer ref="billObserver">
        <div class="row">
          <div class="col-md-3 col-sm-12 mr-md">
            <validation-provider v-slot="{ errors }" :rules="'required'">
              <custom-drop-down
                v-model="model.academicYear"
                :custom-error-msg="'El año académico es requerido.'"
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Año Académico:"
                :options="academicYears"
                placeholder="Seleccione"
                @input="onChangeAcademicYear"
              />
            </validation-provider>
          </div>
          <div class="col-md-3 col-sm-12">
            <validation-provider v-slot="{ errors }" :rules="'required'">
              <custom-drop-down
                v-model="model.month"
                :custom-error-msg="'El mes es requerido.'"
                :error="errors[0]"
                fieldkey="monthNumber"
                fieldname="monthDesc"
                label="Mes:"
                :options="catalog.months"
                placeholder="Seleccione"
                @input="onChangeMonth"
              />
            </validation-provider>
          </div>
          <div v-if="!hasCompany" class="col-md-3 col-sm-12">
            <validation-provider v-slot="{ errors }" :rules="'required'">
              <custom-drop-down
                v-model="model.provider"
                :custom-error-msg="'El proveedor es requerido.'"
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Proveedor:"
                :options="catalog.providers"
                placeholder="Seleccione"
              />
            </validation-provider>
          </div>
          <div class="col-md-2 col-sm-12 mt-md">
            <div class="mt-2 pt-2 d-flex align-items-sm mr-md d-md-inline-flex">
              <action-button
                i="fas fa-times-circle"
                text="Cerrar"
                variant="outline-danger mr-3 pl-3 pr-4"
                @click="onCancel"
              />
              <action-button
                i="fas fa-arrow-alt-circle-right"
                text="Continuar"
                variant="success pl-3 pr-3"
                @click="onSubmit"
              />
            </div>
          </div>
        </div>
      </validation-observer>
    </div>
  </custom-callout>
</template>
<script>
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import IconView from './IconView.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
export default {
  name: 'CreateBill',
  components: {
    ActionButton,
    CustomCallout,
    CustomDropDown,
    IconView,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    defaultProviderId: {
      type: Object,
      default: () => {},
    },
    academicYears: {
      type: Array,
      default: () => [],
    },
    getMonths: {
      type: Function,
      default: () => {},
    },
    getProviders: {
      type: Function,
      default: () => {},
    },
  },
  data: () => ({
    model: {
      provider: null,
      academicYear: null,
      month: null,
    },
    catalog: {
      months: [],
      providers: [],
    },
  }),
  computed: {
    hasCompany() {
      return (
        this.defaultProviderId !== undefined && this.defaultProviderId.id > 0
      );
    },
  },
  methods: {
    async onChangeAcademicYear() {
      if (
        this.model.academicYear !== undefined &&
        this.model.academicYear !== null
      ) {
        const { data } = await this.getMonths()(this.model.academicYear.id);
        this.catalog.months = data;
        this.model.month = null;
        //Set Providers
        if (!this.hasCompany) {
          const { data: providers } = await this.getProviders()(
            this.model.academicYear.id
          );
          this.catalog.providers = providers;
          this.model.provider = null;
        } else {
          this.model.provider = this.defaultProviderId;
        }
      } else {
        this.catalog.months = [];
        this.model.month = null;
        this.model.provider = null;
        this.catalog.providers = [];
      }
    },
    async onChangeMonth() {
      if (!this.hasCompany) {
        const { data: providers } = await this.getProviders()(
          this.model.academicYear.id,
          this.model.month.monthNumber
        );
        this.catalog.providers = providers;
        this.model.provider = null;
      } else {
        this.model.provider = this.defaultProviderId;
      }
    },
    onCancel() {
      // Reset Filter
      this.$emit('on-close');
    },
    async onSubmit() {
      //Validate
      var isValid = await this.$refs.billObserver.validate();
      if (isValid) {
        this.$emit('on-submit', this.model);
      }
    },
  },
};
</script>
<style>
.border-top--color-orangeLight {
  border-top-color: #ff7058 !important;
}
.border-left--color-orangeLight {
  border-left-color: #ff7058 !important;
}
@media screen and (min-width: 952px) {
  .mr-md {
    margin-right: 4px;
  }
  .mt-md {
    margin-top: 1rem;
  }
}
@media screen and (max-width: 390px) {
  .mt-md {
    margin-top: 1rem;
  }
}
</style>
